// reducer for groups a.k.a. spheres a.k.a. communities in the activity center
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { CREATE_GROUP_SUCCESS, FETCH_GROUPS_SUCCESS, SELECT_TOPIC, TOGGLE_GROUP_VISIBILITY_SUCCESS, UPDATE_GROUP_SUCCESS } from "../actions";
import initialState from "./initialState";
import { filter, find } from "lodash";
export default function groups() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : initialState.groups, action = arguments.length > 1 ? arguments[1] : void 0;
    var newGroups = [];
    var noteGroup;
    var selectedGroup;
    var groupIdx;
    switch(action.type){
        case FETCH_GROUPS_SUCCESS:
            newGroups = filter(action.groups, {
                note: false
            });
            noteGroup = find(action.groups, {
                note: true
            }) || null;
            return _objectSpreadProps(_objectSpread({}, state), {
                groups: newGroups,
                noteGroup: noteGroup
            });
        case CREATE_GROUP_SUCCESS:
            console.log("**** action", action);
            newGroups = state.groups.slice();
            newGroups.push(action.group);
            return _objectSpreadProps(_objectSpread({}, state), {
                groups: newGroups
            });
        case UPDATE_GROUP_SUCCESS:
            newGroups = state.groups.slice();
            groupIdx = state.groups.findIndex(function(group) {
                return group.id === action.group.id;
            });
            newGroups[groupIdx] = action.group;
            return _objectSpreadProps(_objectSpread({}, state), {
                groups: newGroups
            });
        case SELECT_TOPIC:
            {
                newGroups = state.groups.slice();
                if (!!action.topic && action.topic.unread > 0) {
                    groupIdx = state.groups.findIndex(function(group) {
                        return group.id === action.topic.group_id;
                    });
                    selectedGroup = state.groups[groupIdx];
                    if (selectedGroup) {
                        selectedGroup.unread_topics = Math.max(selectedGroup.unread_topics - 1, 0);
                        newGroups[groupIdx] = selectedGroup;
                    }
                }
                return _objectSpreadProps(_objectSpread({}, state), {
                    groups: newGroups
                });
            }
        case TOGGLE_GROUP_VISIBILITY_SUCCESS:
            {
                newGroups = state.groups.slice();
                groupIdx = state.groups.findIndex(function(group) {
                    return group.id === action.group.id;
                });
                newGroups[groupIdx] = action.group;
                return _objectSpreadProps(_objectSpread({}, state), {
                    groups: newGroups
                });
            }
        default:
            return state;
    }
}
